<template>
	<div class="customer-benefits">
		<div class="customer-benefits--items">
			<b-row>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Unlimitierte Jobs"
							text="Egal, wie viele Jobprofile du anlegst. Du zahlst erst, wenn du Kontaktanfragen annimmst oder sendest."
							color="purple"
						/>
						<Item
							title="Kontaktsystem & Bewerbermanagement"
							text="Du nimmst direkt Kontakt mit ausgewählten Bewerbern auf, vereinbarst einfach Gesprächstermine, startest Vertragsverhandlungen und sendest Zu- bzw. Absagen. Entwickelt aus jahrzehntelanger, täglicher Erfahrung von Personalisten."
							color="orange"
						/>
					</div>
				</b-col>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Unlimitierte Filter"
							text="Setze kostenlos so viele Filter, wie du willst.<br/>Achtung: Zu viele Filter können die Suchergebnisse des Best-Match-Systems auch zu stark einschränken!"
							color="turquoise"
						/>
						<Item
							title="Ein Guthaben für alle Jobs."
							text="Egal wie viele Job-Profile du anlegst: erst wenn du Personen kontaktieren willst, kaufst Du ein Guthaben und kannst es für verschiedene Jobs verwenden. Du brauchst also kein Einzelguthaben je Job-Profil. Das ist kostengünstiger und du behältst die Übersicht.<br/><b>skilldoo bietet absolute Kostentransparenz.</b>"
							color="olive"
						/>
					</div>
				</b-col>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Anonym"
							text="Du kannst Stellen anonym ausschreiben. Denn eventuell ist die ausgeschriebene Position noch besetzt."
							color="gold"
						/>
						<Item
							title="Passend, einfach und schnell"
							text="Durch das Best-Match-System werden nur passende BewerberInnen angezeigt. Damit sparst du Zeit und Geld."
							color="lime"
						/>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import Item from "./customer-benefits/Item.vue";

const HOW_IT_WORKS_ITEMS = [
	{
		text: 'Jobprofil veröffentlichen',
		items: [
			'schnell mit wenigen Klicks',
			'einfach'
		],
		free: true,
	},
	{
		text: 'Best-Match-System zeigt passende Bewerber',
		items: [
			'einfach Notizen erstellen',
			'passende Personen vormerken'
		],
		free: true,
	},
	{
		text: 'Kontaktanfragen',
		items: [
			'annehmen',
			'senden'
		],
		free: false,
	},
	{
		text: 'Weitere Jobprofile anlegen und veröffentlichen',
		items: [
			'unbeschränkte Anzahl',
			'noch weniger Zeitaufwand'
		],
		free: true,
	},
	{
		text: 'Termine',
		items: [
			'vereinbaren',
			'zusagen',
			'absagen'
		],
		free: true,
	},
];

export default {
	components: {Item, Icon},

	props: {
		onWhite: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	computed: {
		howItWorksItems ()
		{
			return HOW_IT_WORKS_ITEMS;
		}
	}
}
</script>
